/**
 * Версия последней записи «Что нового» — отдельным крошечным файлом.
 *
 * Зачем отдельно. Шапка сайта показывает точку «есть непрочитанное», сравнивая
 * эту строку с тем, что лежит в localStorage. Раньше она импортировала её из
 * lib/whats-new.ts, а это 140 КБ и 207 записей: каждая страница сервиса тянула
 * весь список ради одной строки и разбирала массив из двухсот объектов в
 * главном потоке до того, как страница станет отзывчивой. На странице входа,
 * где список вообще не нужен, это особенно обидно (аудит 2026-09-07).
 *
 * Значение обязано совпадать с id ПЕРВОЙ записи в WHATS_NEW_ITEMS. За этим
 * следит tests/whats-new-version.test.ts: добавили запись и забыли обновить
 * строку — тест падает, а не точка «непрочитанное» молча перестаёт появляться.
 */
export const LATEST_WHATS_NEW_VERSION = "product-history";
export const WHATS_NEW_SEEN_KEY = "frogstat_whats_new_seen_at";
export const WHATS_NEW_SEEN_EVENT = "frogstat:whats-new-seen";
